import {defineStore} from "pinia";
import {QuestionsStore} from "./QuestionsStore";
import {FormDataStore} from "./FormDataStore";
import axios from "axios";

export const bookingFlowStore = defineStore("bookingFlow", {
    state: () => ({
        submittingBooking: false,
        step: 1,
        errors: [],
    }),
    getters: {
        currentQuestion: (state) => {
            const questionsStore = QuestionsStore();
            return questionsStore.questions[state.step];
        },
        lastStep: () => {
            const questionsStore = QuestionsStore();
            return parseInt(Object.keys(questionsStore.questions).pop());
        },
        error: () => {
            const formDataStore = FormDataStore();
            return formDataStore.error;
        }
    },
    actions: {
        continueFlow() {
            const questionsStore = QuestionsStore();
            const formDataStore = FormDataStore();
            this.errors = questionsStore.questions[this.step].validate(formDataStore.formData[questionsStore.questions[this.step].name]);

            if (this.errors.length === 0) {
                if (this.step < this.lastStep) {
                    this.step++;
                }
            }
        },
        back() {
            if (this.step > 1) {
                this.step--;
            }
        },
        async submitBooking() {
            const questionsStore = QuestionsStore();
            const formDataStore = FormDataStore();

            this.errors = questionsStore.questions[this.step].validate(formDataStore.formData[questionsStore.questions[this.step].name]);

            if (this.errors.length === 0) {
                try {
                    this.submittingBooking = true;
                    const response = await axios.post("/wp-json/booking/v1/submit-list/", formDataStore.formData);
                    const reference = response.data.reference;
                    window.location.replace("/booking/thank-you/?reference=" + reference);
                } catch (error) {
                    this.submittingBooking = false;
                    formDataStore.formData.bookingCalendar.date = null;
                    this.errors.push("There has been an error submitting your booking, please refresh and try again");
                }
            }
        },
    },
});